/**
 * Logger configurable para la aplicacion
 * Deshabilita logs en produccion automaticamente
 */

const isDevelopment = import.meta.env.DEV;

const noop = () => {};

const createLogger = (prefix = "") => {
  const formatMessage = (level, ...args) => {
    const timestamp = new Date().toISOString();
    return [`[${timestamp}] [${level}]${prefix ? ` [${prefix}]` : ""}`, ...args];
  };

  return {
    debug: isDevelopment
      ? (...args) => console.log(...formatMessage("DEBUG", ...args))
      : noop,

    info: isDevelopment
      ? (...args) => console.info(...formatMessage("INFO", ...args))
      : noop,

    warn: (...args) => console.warn(...formatMessage("WARN", ...args)),

    error: (...args) => console.error(...formatMessage("ERROR", ...args)),
  };
};

// Logger principal
export const logger = createLogger();

// Factory para crear loggers con prefijo
export const createPrefixedLogger = (prefix) => createLogger(prefix);

export default logger;
